/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from 'react';
import { useTable, useSortBy, usePagination } from 'react-table';
import { useNavigate, Link } from 'react-router-dom';
import './DocumentListTable.scss';
import CustomClientError from 'src/Member/errorhandling/CustomClientError';
import useDate from 'src/Admin/utils/useDate';

const DocumentListTable = ({
  columns,
  data,
  pageSizeCount,
  labelProp = 'Documents List',
  initialSortBy = {},
  customSortingHandler,
}) => {
  //console.log( data, 'data' );
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  //Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    footerGroups,
    prepareRow,
    page,
    setPageSize,
    pageCount,

    state: { sortBy },
  } = useTable(
    {
      columns,
      data,
      disableSortRemove: true,
      initialState: {
        pageIndex: 0,
        pageSize: pageSizeCount,
        sortBy: [initialSortBy],
      },
      manualSortBy: true,
    },
    useSortBy,
    usePagination,
  );

  const { formatDate } = useDate();

  const onClick = (ele) => {
    if (ele) {
      console.log(ele, 'PageRedirect');
      navigate('/member/view-documents', {
        state: ele?.original,
      });
    }
  };

  const linkFormatter = (value) => {
    return (
      <Link to="/member/view-documents">
        <span className="link-colors">{value}</span>
      </Link>
    );
  };

  useEffect(() => {
    customSortingHandler(sortBy[0]?.id, sortBy[0]?.desc, sortBy);
  }, [sortBy]);

  useMemo(() => {
    setPageSize(pageSizeCount);
  }, [pageSizeCount]);
  //Render the UI for your table
  return (
    <>
      <div className="document-list-table">
        <table
          className="table padding-mobile-0"
          {...getTableProps()}
          aria-rowcount={data?.length}
          onBlur={() => setIsLoading(true)}
        >
          <caption className="sr-only">{labelProp}</caption>
          {data?.length > 0 && (
            <thead>
              {headerGroups.map((headerGroup, index) => (
                <tr
                  key={index}
                  {...headerGroup.getHeaderGroupProps()}
                  role="row"
                >
                  {headerGroup.headers.map((column, index) => (
                    <th
                      key={index}
                      {...column.getHeaderProps(
                        column.getSortByToggleProps({ title: undefined }),
                      )}
                      scope="col"
                      role="columnheader"
                      onKeyPress={(event) => {
                        if (
                          column.sortable !== false &&
                          event.key === 'Enter'
                        ) {
                          column.toggleSortBy();
                        }
                      }}
                      className={
                        column.isSorted ? 'coloumnIsSorted' : 'coloumnNotSorted'
                      }
                    >
                      <b>{column.render('Header')}</b>
                      <span
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'arrowDown'
                              : 'arrowUp'
                            : 'arrowNormal'
                        }
                        tabIndex={0}
                        aria-label={
                          column.isSorted
                            ? column.isSortedDesc
                              ? ` ${column.Header} sorted descending`
                              : ` ${column.Header} sorted ascending`
                            : ` ${column.Header} sorted none`
                        }
                        aria-live="polite"
                        aria-atomic={isLoading}
                        aria-sort={
                          column.isSorted
                            ? column.isSortedDesc
                              ? 'descending'
                              : 'ascending'
                            : 'none'
                        }
                      ></span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
          )}
          <tbody {...getTableBodyProps()} role="rowgroup">
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <tr key={index} {...row.getRowProps()}>
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        {...cell.getCellProps()}
                        role="cell"
                        onClick={() => (index === 0 ? onClick(row) : null)}
                      >
                        {/*{index === 0 ? linkFormatter( cell.render( 'Cell' ) ) : cell.render( 'Cell' )} */}
                        <p className="document-data">
                          {index === 0
                            ? linkFormatter(cell.render('Cell'))
                            : index === 2
                            ? formatDate(cell?.row?.original?.SentDate)
                            : cell.render('Cell')}
                        </p>
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        {data?.length == 0 && (
          <div className="document-no-data text-center">
            <CustomClientError
              CustomClasses="p-0 m-0"
              ErrorHeading="No Documents found!"
              ErrorMessage="We could not find any documents for the selected filter(s).
            Use another filter(s) and try again."
            />
          </div>
        )}
      </div>
    </>
  );
};

export default DocumentListTable;
